import React                  from 'react';
import { GeneratorDialogModel }    from '../schedule/GeneratorDialogModel';
import { Theme, makeStyles }       from '../utility/styles';
import SettingsModel               from './SettingsModel';
import{ GeneratorDialogContents }  from '../schedule/GeneratorDialog';

const styles = (_theme: Theme) => ({
  form: {
    marginTop: '10px',
  },
  content: {
    margin: '0px 0px 15px 0px !important',
  },
  repeatDaysContainer: {
    margin: '0px 0px 10px 0px',
  },
  templatesContainer: {
    margin: '0px 0px 10px 0px',
  },
  calendarContainer: {
    margin: '0px',
  },
});

const useStyles = makeStyles(styles);

const TemplateEditorView = React.memo(({ editor }: { editor: GeneratorDialogModel, settings: SettingsModel }) => {
  const classes = useStyles();
  return (
    < >
      <GeneratorDialogContents model={editor} classes={classes} />
    </>
  );
});

export default TemplateEditorView;
